import Button from '@components/button';
import Container from '@components/container';
import Img from '@components/img';
import Socials from '@components/socials';
import { Yeseva } from 'app/fonts';
import classNames from 'classnames';
import Pricing from 'features/pricing';
import Link from 'next/link';
import type { ReactElement } from 'react';
import React from 'react';
import type { DataProps } from 'types/props/data-props';
import type { Stylist } from 'types/stylist';
import mapLevelToLabel from 'utils/map-level-to-label';
import mapRoleToLabel from 'utils/map-role-to-label';
import { validateString } from 'utils/validate-string';

import styles from './stylist-page.module.scss';

const disclaimerClass = validateString(styles.disclaimer);
const imageClass = validateString(styles.image);
const rootClass = validateString(styles.root);
const profileClass = validateString(styles.profile);
const pricingClass = validateString(styles.pricing);
const nameClass = validateString(styles.name);
const nameRow = validateString(styles.nameRow);

export default function StylistPage({
  image,
  level,
  name,
  role,
  prices,
  socials,
}: Readonly<DataProps<Stylist>>): ReactElement {
  const levelRole =
    role === 'stylist'
      ? mapLevelToLabel(level)
      : `${mapLevelToLabel(level)} / ${mapRoleToLabel(role)}`;

  return (
    <Container className={rootClass}>
      <div className={profileClass}>
        <Img
          alt={name}
          className={imageClass}
          effect="box-right"
          imageSource={image}
          imageStyle="arch"
          priority
          sizes="(max-width: 768px) 100vw, 25vw"
        />
        <div className={nameRow}>
          <h1 className={classNames(nameClass, Yeseva.className)}>
            {name.toUpperCase()}
          </h1>
          {/* <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>|</span> */}
          <span>{levelRole}</span>
        </div>
        <Socials>{socials}</Socials>

        <Link href="https://kandcosalon.mysalononline.com/">
          <Button>Book now!</Button>
        </Link>
      </div>

      {typeof prices !== 'undefined' && (
        <div className={pricingClass}>
          <p className={disclaimerClass}>
            *Prices for all services may change depending on hair texture and
            density. Please call for more info
          </p>
          <Pricing pricing={prices} />
        </div>
      )}
    </Container>
  );
}
